<template>
	<AmeliproHeaderBar
		:home-href="
			ameliproHeaderInfos && ameliproHeaderInfos.homeHref
				? ameliproHeaderInfos.homeHref
				: homeHref
		"
		:home-link="
			ameliproHeaderInfos && ameliproHeaderInfos.homeLink
				? ameliproHeaderInfos.homeLink
				: homeLink
		"
		:inner-width="innerWidth"
		:service-sub-title="
			ameliproHeaderInfos && ameliproHeaderInfos.serviceSubTitle
				? ameliproHeaderInfos.serviceSubTitle
				: serviceSubTitle
		"
		:service-title="
			ameliproHeaderInfos && ameliproHeaderInfos.headerTitle
				? ameliproHeaderInfos.headerTitle
				: headerTitle
		"
		style="z-index: 1"
		:theme-amelipro="
			(ameliproHeaderInfos && ameliproHeaderInfos.headerTitle) || headerTitle
				? false
				: true
		"
	>
		<template #default>
			<slot
				v-if="!noRightPart"
				name="rightPart"
			>
				<div
					v-if="!noRightPart"
					class="amelipro-header__right-part"
				>
					<AmeliproIconBtn
						v-if="unlogged"
						color="ap-blue"
						icon="aide"
						icon-bg-color="ap-white"
						icon-color="ap-blue"
						icon-hover-bg-color="ap-blue"
						icon-hover-color="ap-white"
						large
					>
						<template #prepend>
							<span class="text-none"> Aide </span>
						</template>
					</AmeliproIconBtn>

					<nav
						v-if="!unlogged"
						class="d-flex align-center amelipro-header__nav"
						role="navigation"
					>
						<div
							v-if="breakpointHelper.isDesktop()"
							class="d-none d-md-block text-right amelipro-header__infos"
						>
							<div class="font-size-xs ap-grey--text text--darken-1">
								<slot name="userInformationSummary">
									<div
										v-if="
											ameliproHeaderInfos &&
												ameliproHeaderInfos.userInformationSummaryInfos
										"
									>
										<UserInformationSummary
											:user-information-summary-infos="
												ameliproHeaderInfos.userInformationSummaryInfos
											"
										/>
									</div>
								</slot>
							</div>
						</div>

						<hr
							v-if="breakpointHelper.isDesktop()"
							class="d-none d-md-block mx-6 border-0 header-separator"
						>

						<ul class="list-style-none d-flex amelipro-header__nav__list">
							<li
								v-if="hasUserMenu"
								class="mr-2 mr-sm-4 amelipro-header__nav__item"
							>
								<slot name="userMenu">
									<div
										v-if="
											ameliproHeaderInfos && ameliproHeaderInfos.userMenuInfos
										"
									>
										<UserMenu
											:last-connexion="
												ameliproHeaderInfos.userMenuInfos.lastConnexion
											"
											:user-menu-infos="ameliproHeaderInfos.userMenuInfos"
											@click:account="account"
											@click:logout="logout"
										/>
									</div>
								</slot>
							</li>

							<li
								v-if="hasStructureMenu && breakpointHelper.isDesktop()"
								class="d-none d-md-block mr-2 mr-sm-4 amelipro-header__nav__item"
							>
								<slot name="structureMenu">
									<div
										v-if="
											ameliproHeaderInfos &&
												ameliproHeaderInfos.displayStructureWebComponent
										"
									>
										<amgs-wc
											:ouverture-auto.prop="true"
											@amgs-validate="updateSelectionStructure"
										/>
									</div>
								</slot>
							</li>

							<li
								v-if="hasServiceMenu"
								class="mr-2 mr-sm-4 amelipro-header__nav__item"
							>
								<slot name="serviceMenu">
									<div
										v-if="
											ameliproHeaderInfos &&
												ameliproHeaderInfos.displayServiceWebComponent
										"
									>
										<menu-bulle-wc />
									</div>
								</slot>
							</li>

							<li
								v-if="hasNotificationMenu && breakpointHelper.isDesktop()"
								class="amelipro-header__nav__item"
							>
								<slot name="notificationMenu" />
							</li>
						</ul>
					</nav>
				</div>
			</slot>
		</template>

		<template
			v-if="!noSubPart"
			#navigation-bar-content
		>
			<div
				class="d-flex justify-center navigation-bar-content-wrapper w-100 amelipro-header__sub-bar"
			>
				<AmeliproMenu
					v-if="subMenu"
					:amelipro-href="ameliproHeaderInfos?.ameliproHref || ameliproHref"
					class="navigation-bar-left-btn"
					:items="subMenuItems"
					:menu-header="
						ameliproHeaderInfos && ameliproHeaderInfos.serviceName
							? ameliproHeaderInfos.serviceName
							: serviceName
					"
				/>

				<AmeliproIconBtn
					v-else
					:btn-label="backBtnLabel"
					class="navigation-bar-left-btn"
					:href="backBtnHref"
					icon="chevronLeft"
					icon-bg-color="transparent"
					icon-color="ap-white"
					icon-hover-bg-color="transparent"
					icon-hover-color="ap-grey lighten-5"
					large
					:to="backBtnTo"
					@click="backBtnEvent"
				/>

				<h1 class="ap-white--text text-service-title">
					<AmeliproBtn
						class="text-service-title"
						color="ap-white"
						hover-color="ap-white"
						:href="serviceHomeHref"
						text
						:to="serviceHomeTo"
					>
						{{
							ameliproHeaderInfos && ameliproHeaderInfos.serviceName
								? ameliproHeaderInfos.serviceName
								: serviceName
						}}

						<span
							v-if="
								backoffice ||
									(ameliproHeaderInfos && ameliproHeaderInfos.backoffice)
							"
						>
							<span
								v-if="
									(ameliproHeaderInfos && ameliproHeaderInfos.serviceName) ||
										serviceName
								"
							>&nbsp;-&nbsp;</span>back office
						</span>
					</AmeliproBtn>
				</h1>
			</div>
		</template>
	</AmeliproHeaderBar>
</template>

<script setup lang="ts">
	import { PropType, computed, useSlots } from 'vue';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import AmeliproHeaderBar from '../AmeliproHeaderBar/AmeliproHeaderBar.vue';
	import { AmeliproHeaderInfos } from './types';
	import AmeliproIconBtn from '../AmeliproIconBtn/AmeliproIconBtn.vue';
	import AmeliproMenu from '../AmeliproMenu/AmeliproMenu.vue';
	import { AmeliproMenuItem } from '../AmeliproMenu/types';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { RawLocation } from 'vue-router';
	import UserInformationSummary from '../UserInformationSummary';
	import UserMenu from '../UserMenu/UserMenu.vue';

	const props = defineProps({
		ameliproHeaderInfos: {
			type: Object as PropType<AmeliproHeaderInfos>,
			default: undefined,
		},
		backBtnHref: {
			type: String,
			default: undefined,
		},
		backBtnLabel: {
			type: String,
			default: 'Retour',
		},
		backBtnTo: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
		backoffice: {
			type: Boolean,
			default: false,
		},
		headerTitle: {
			type: String,
			default: undefined,
		},
		homeHref: {
			type: String,
			default: undefined,
		},
		ameliproHref: {
			type: String,
			default: undefined,
		},
		homeLink: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
		noRightPart: {
			type: Boolean,
			default: false,
		},
		noSubPart: {
			type: Boolean,
			default: false,
		},
		serviceHomeHref: {
			type: String,
			default: undefined,
		},
		serviceHomeTo: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
		serviceName: {
			type: String,
			default: undefined,
		},
		serviceSubTitle: {
			type: String,
			default: undefined,
		},
		subMenu: {
			type: Boolean,
			default: false,
		},
		subMenuItems: {
			type: Array as PropType<AmeliproMenuItem[]>,
			default: () => [],
		},
		unlogged: {
			type: Boolean,
			default: false,
		},
	});

	const slots = useSlots();
	const breakpointHelper = new BreakpointHelper('smAndUp');

	const innerWidth = computed<string>(() => {
		if (breakpointHelper.width >= 1240) {
			return '1144px';
		}
		return breakpointHelper.width >= 1072 ? '980px' : '100%';
	});
	const hasUserMenu = computed<boolean>(() => Boolean(slots.userMenu || props.ameliproHeaderInfos?.userMenuInfos));
	const hasStructureMenu = computed<boolean>(() => Boolean(slots.structureMenu ||
		props.ameliproHeaderInfos?.displayStructureWebComponent));
	const hasServiceMenu = computed<boolean>(() => Boolean(slots.serviceMenu || props.ameliproHeaderInfos?.displayServiceWebComponent));
	const hasNotificationMenu = computed<boolean>(() => Boolean(slots.notificationMenu));

	const emit = defineEmits(['back-btn-click']);

	const backBtnEvent = (): void => emit('back-btn-click');

	const logout = (): void => {
		if (props.ameliproHeaderInfos?.userMenuInfos?.logout) {
			props.ameliproHeaderInfos?.userMenuInfos?.logout();
		}
	};

	const account = (): void => {
		if (props.ameliproHeaderInfos?.userMenuInfos?.account) {
			props.ameliproHeaderInfos?.userMenuInfos?.account();
		}
	};

	const updateSelectionStructure = (event: Event): void => {
		if (props.ameliproHeaderInfos?.userMenuInfos?.updateSelectionStructure) {
			props.ameliproHeaderInfos?.userMenuInfos?.updateSelectionStructure(event);
		}
	};
</script>

<style lang="scss" scoped>
.header-separator {
  width: 1px;
  height: 38px;
  background-color: $ap-blue-darken1;
}

.header-bar-container {
  & :deep(.navigation-bar-content-wrapper) {
    position: relative;
    padding: 0 38px;

    & .v-btn:focus {
      outline-color: $ap-white;
    }
  }

  & .navigation-bar-left-btn {
    position: absolute;
    top: calc(50% - 13px);
    left: 0;
  }
}
</style>
